import { render } from "./StatHits.vue?vue&type=template&id=530e96d8&scoped=true"
import script from "./StatHits.vue?vue&type=script&lang=js"
export * from "./StatHits.vue?vue&type=script&lang=js"

import "./StatHits.vue?vue&type=style&index=0&id=530e96d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530e96d8"]])

export default __exports__